<template>
  <transition mode="out-in">
    <widget-alert
      v-if="visibleAlert"
      :key="visibleAlert.id"
      :is-rounded="isRounded"
      @close="removeAlert(visibleAlert.id)"
    >
      {{ visibleAlert.text }}

      <template
        v-if="visibleAlert.onRefresh"
        v-slot:action
      >
        <widget-link
          class="alert-refresh-button"
          variant="primary"
          size="12"
          @click="visibleAlert.onRefresh()"
        >
          <div class="d-flex align-center gap-1">
            <widget-icon
              name="refresh"
              size="14px"
            />
            {{ $t('common.refresh') }}
          </div>
        </widget-link>
      </template>
    </widget-alert>
  </transition>
</template>

<script setup lang="ts">
import WidgetIcon from '@widgets/shared/components/WidgetIcon.vue'
import WidgetAlert from '@widgets/shared/components/WidgetAlert.vue'
import { useWidgetAlerts } from '@widgets/messenger/compositions/useWidgetAlerts'
import type { MessengerAlertScope } from '@widgets/messenger/types/alert'
import WidgetLink from '@widgets/shared/components/WidgetLink.vue'

const { scopes } = defineProps<{
  scopes: MessengerAlertScope[]
  isRounded?: boolean
}>()

const { visibleAlert, removeAlert } = useWidgetAlerts(() => scopes)
</script>

<style lang="scss" scoped>
.v-enter-active,
.v-leave-active {
  transition:
    opacity $transition-100ms-ease-in-out,
    transform $transition-100ms-ease-in-out;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.alert-refresh-button {
  line-height: 20px !important;
}
</style>
